export default __webpack_public_path__ + "static/media/map-1.7c626d78.jpg";